import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { Tooltip, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import { useToggle } from 'usehooks-ts';

import { ParameterReferenceModal } from './ParameterReferenceModal';

const ParametersToolbar = () => {
  const theme = useTheme();
  const [showParameterReferenceModal, toggleParameterReferenceModal] =
    useToggle();

  return (
    <Box boxShadow={3} borderRadius={1} bgcolor={theme.palette.common.white}>
      <Tooltip title="Parameter reference" placement="right">
        <ToggleButton
          value={{}}
          selected={showParameterReferenceModal}
          onClick={toggleParameterReferenceModal}
        >
          <TuneOutlinedIcon color="neutral" />
        </ToggleButton>
      </Tooltip>

      {showParameterReferenceModal && (
        <ParameterReferenceModal onClose={toggleParameterReferenceModal} />
      )}
    </Box>
  );
};

export default ParametersToolbar;
